interface UserAvatarProps {
    src?: string;
    name: string;
    size?: 'sm' | 'md' | 'xs';
    onClick?: () => void;
}

const SIZE_CLASSES = {
    xs: 'size-5 text-[9px]',
    sm: 'size-8 text-xs',
    md: 'size-10 text-sm',
} as const;

function getInitials(name: string): string {
    return name
        .split(' ')
        .filter((word) => word.length > 0)
        .map((word) => word[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
}

export function UserAvatar({
    src,
    name,
    size = 'md',
    onClick,
}: UserAvatarProps) {
    const sizeClass = SIZE_CLASSES[size];

    return (
        <div
            className={`flex items-center ${onClick ? 'cursor-pointer' : ''}`}
            onClick={onClick}
        >
            {src ? (
                <img
                    src={src}
                    alt={name}
                    className={`${sizeClass} rounded-full object-cover`}
                />
            ) : (
                <div
                    className={`${sizeClass} rounded-full bg-brand text-white flex items-center justify-center font-semibold`}
                >
                    {getInitials(name)}
                </div>
            )}
        </div>
    );
}
